import { takeEvery, put, call } from "redux-saga/effects";
import apiCall from "../services";

const apiUrl = process.env.REACT_APP_API_URL;
const enviromentUrl = process.env.REACT_APP_ENVIROMENT;

function* getAccountList(actions) {
  let uuid = actions.idUser ? actions.idUser : getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      actions.query === null
        ? apiUrl + "/opa-accounts?page=" + actions.page
        : apiUrl + "/opa-accounts" + actions.query;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    yield put({ type: "LIST_ACCOUNT_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "LIST_ACCOUNT_RESPONSE_GET", value: error });
  }
}

function* getAccountListFiltered(actions) {
  let uuid = actions.idUser ? actions.idUser : getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      actions.query === null
        ? apiUrl + "/opa-accounts?page=" + actions.page
        : apiUrl + "/opa-accounts" + actions.query;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    yield put({ type: "LIST_ACCOUNT_FILTERED_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "LIST_ACCOUNT_FILTERED_RESPONSE_GET", value: error });
  }
}

function* getAccount(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      actions.query === null
        ? apiUrl + "/opa-account/"
        : apiUrl + "/opa-account/" + actions.query;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    yield put({ type: "ACCOUNT_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "ACCOUNT_RESPONSE_GET", value: error });
  }
}

function* resetAccount() {
  yield put({ type: "ACCOUNT_RESPONSE_RESET" });
}

function* createAccount(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-account";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.created) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "ACCOUNT_RESPONSE_ADD",
      value: { ...response, responseStatus },
    });
    return response;
  } catch (error) {
    yield put({
      type: "ACCOUNT_RESPONSE_ADD",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* editAccount(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-account/" + actions.id;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "PATCH", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.updatedAt || response.uuid) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "ACCOUNT_RESPONSE_EDIT",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "ACCOUNT_RESPONSE_EDIT",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* createAccountAddress(actions) {
  let uuid = getSetCookie();

  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-account-address/" + actions.id;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    yield put({
      type: "ACCOUNT_ADDRESS_RESPONSE_ADD",
      value: {
        ...response,
        responseStatus: response.statusCode === 500 ? "error" : "success",
      },
    });
  } catch (error) {
    yield put({
      type: "ACCOUNT_ADDRESS_RESPONSE_ADD",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* editAccountAddress(actions) {
  let uuid = getSetCookie();

  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-account-address/" + actions.id;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "PATCH", url, requestOptions);

    yield put({
      type: "ACCOUNT_ADDRESS_RESPONSE_EDIT",
      value: {
        ...response,
        responseStatus: response.statusCode === 500 ? "error" : "success",
      },
    });
  } catch (error) {
    yield put({
      type: "ACCOUNT_ADDRESS_RESPONSE_EDIT",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* getAccountBank(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url = apiUrl + "/opa-account-bank/" + actions.id;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    yield put({ type: "ACCOUNT_BANK_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "ACCOUNT_BANK_RESPONSE_GET", value: error });
  }
}

function* createAccountBank(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-account-bank/" + actions.id;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    yield put({
      type: "ACCOUNT_BANK_RESPONSE_ADD",
      value: {
        ...response,
        responseStatus: response.statusCode === 500 ? "error" : "success",
      },
    });
  } catch (error) {
    yield put({
      type: "ACCOUNT_BANK_RESPONSE_ADD",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* editAccountBank(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-account-bank/" + actions.id;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "PATCH", url, requestOptions);

    yield put({
      type: "ACCOUNT_BANK_RESPONSE_EDIT",
      value: {
        ...response,
        responseStatus: response.statusCode === 500 ? "error" : "success",
      },
    });
  } catch (error) {
    yield put({
      type: "ACCOUNT_BANK_RESPONSE_EDIT",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* getAccountImages(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url = apiUrl + "/opa-account-images/" + actions.id;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    yield put({ type: "ACCOUNT_IMAGE_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "ACCOUNT_IMAGE_RESPONSE_GET", value: error });
  }
}

function* createAccountImage(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-account-image/" + actions.id;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    yield put({
      type: "ACCOUNT_IMAGE_RESPONSE_ADD",
      value: {
        ...response,
        responseStatus: response.statusCode === 500 ? "error" : "success",
      },
    });
  } catch (error) {
    yield put({
      type: "ACCOUNT_IMAGE_RESPONSE_ADD",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* editAccountImage(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url =
      apiUrl + "/opa-account-image/" + actions.id + "/" + actions.idImage;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "PATCH", url, requestOptions);

    yield put({
      type: "ACCOUNT_IMAGE_RESPONSE_EDIT",
      value: {
        ...response,
        responseStatus: response.statusCode === 500 ? "error" : "success",
      },
    });
  } catch (error) {
    yield put({
      type: "ACCOUNT_IMAGE_RESPONSE_EDIT",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* deleteAccountImage(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url =
      apiUrl + "/opa-account-image/" + actions.id + "/" + actions.idImage;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "DELETE", url, requestOptions);

    yield put({
      type: "ACCOUNT_IMAGE_RESPONSE_DELETE",
      value: {
        ...response,
        responseStatus: response.statusCode === 500 ? "error" : "success",
      },
    });
  } catch (error) {
    yield put({
      type: "ACCOUNT_IMAGE_RESPONSE_DELETE",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* createAccountImages(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-account-images/" + actions.id;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    yield put({
      type: "ACCOUNT_IMAGE_RESPONSE_ADD",
      value: {
        ...response,
        responseStatus: response.statusCode === 500 ? "error" : "success",
      },
    });
  } catch (error) {
    yield put({
      type: "ACCOUNT_IMAGE_RESPONSE_ADD",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* deleteAccountImages(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-account-images/" + actions.id;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "DELETE", url, requestOptions);

    yield put({
      type: "ACCOUNT_IMAGE_RESPONSE_DELETE",
      value: {
        ...response,
        responseStatus: response.statusCode === 500 ? "error" : "success",
      },
    });
  } catch (error) {
    yield put({
      type: "ACCOUNT_IMAGE_RESPONSE_DELETE",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* getAccountUsers(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      actions.query === null
        ? apiUrl + "/opa-account-users"
        : apiUrl + "/opa-account-users/" + actions.query;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    yield put({ type: "ACCOUNT_USERS_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "ACCOUNT_USERS_RESPONSE_GET", value: error });
  }
}

function* addAccountUsers(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-account-users/" + actions.id;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    let responseStatus = "warning";

    if (response) {
      if (response.status === 200) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "ACCOUNT_USERS_RESPONSE_ADD",
      value: { ...response, responseStatus },
    });
    return response;
  } catch (error) {
    yield put({
      type: "ACCOUNT_USERS_RESPONSE_ADD",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* deleteAccountUser(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      apiUrl + "/opa-account-user/" + actions.id + "/" + actions.form.userId;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "DELETE", url, requestOptions);

    let responseStatus = "warning";

    if (response) {
      if (response.status === 200) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "ACCOUNT_USERS_RESPONSE_DELETE",
      value: { ...response, responseStatus },
    });
    return response;
  } catch (error) {
    yield put({
      type: "ACCOUNT_USERS_RESPONSE_DELETE",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

// function* editAccountProperties(actions) {
//   let uuid = getSetCookie();
//   try {
//     const headers = {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${actions.access}`,
//       "X-RealmUuid": uuid,
//     };

//     const requestOptions = {
//       headers: headers,
//       body: JSON.stringify(actions.form),
//     };

//     let url = apiUrl + "/opa-account-property/" + actions.id;

//     if (enviromentUrl !== "") {
//       if (url.includes("?")) {
//         url += `&env=${enviromentUrl}`;
//       } else {
//         url += `?env=${enviromentUrl}`;
//       }
//     }

//     const response = yield call(apiCall, "PATCH", url, requestOptions);

//     let responseStatus = "warning";
//     if (response) {
//       if (response.updatedAt || response.uuid) {
//         responseStatus = "success";
//       } else {
//         responseStatus = "error";
//       }
//     }

//     yield put({
//       type: "ACCOUNT_RESPONSE_PROPERTY_EDIT",
//       value: {
//         ...response,
//         responseStatus,
//       },
//     });
//   } catch (error) {
//     yield put({
//       type: "ACCOUNT_RESPONSE_PROPERTY_EDIT",
//       value: { ...error, responseStatus: "error" },
//     });
//     throw error;
//   }
// }

export function* getSagaAccountList() {
  yield takeEvery("GET_LIST_ACCOUNT", getAccountList);
}

export function* getSagaAccountListFiltered() {
  yield takeEvery("GET_LIST_ACCOUNT_FILTERED", getAccountListFiltered);
}

export function* getSagaAccount() {
  yield takeEvery("GET_ACCOUNT", getAccount);
}

export function* resetSagaAccount() {
  yield takeEvery("RESET_ACCOUNT", resetAccount);
}

export function* createSagaAccount() {
  yield takeEvery("ADD_ACCOUNT", createAccount);
}

export function* editSagaAccount() {
  yield takeEvery("EDIT_ACCOUNT", editAccount);
}

export function* createSagaAccountAddress() {
  yield takeEvery("ADD_ACCOUNT_ADDRESS", createAccountAddress);
}

export function* editSagaAccountAddress() {
  yield takeEvery("EDIT_ACCOUNT_ADDRESS", editAccountAddress);
}

export function* getSagaAccountBank() {
  yield takeEvery("GET_ACCOUNT_BANK", getAccountBank);
}

export function* createSagaAccountBank() {
  yield takeEvery("ADD_ACCOUNT_BANK", createAccountBank);
}

export function* editSagaAccountBank() {
  yield takeEvery("EDIT_ACCOUNT_BANK", editAccountBank);
}

export function* getSagaAccountImages() {
  yield takeEvery("GET_ACCOUNT_IMAGES", getAccountImages);
}

export function* createSagaAccountImage() {
  yield takeEvery("ADD_ACCOUNT_IMAGE", createAccountImage);
}

export function* editSagaAccountImage() {
  yield takeEvery("EDIT_ACCOUNT_IMAGE", editAccountImage);
}

export function* deleteSagaAccountImage() {
  yield takeEvery("DELETE_ACCOUNT_IMAGE", deleteAccountImage);
}

export function* createSagaAccountImages() {
  yield takeEvery("ADD_ACCOUNT_IMAGES", createAccountImages);
}

export function* deleteSagaAccountImages() {
  yield takeEvery("DELETE_ACCOUNT_IMAGES", deleteAccountImages);
}

export function* getSagaAccountUsers() {
  yield takeEvery("GET_ACCOUNT_USERS", getAccountUsers);
}

export function* addSagaAccountUsers() {
  yield takeEvery("ADD_ACCOUNT_USERS", addAccountUsers);
}

export function* deleteSagaAccountUser() {
  yield takeEvery("DELETE_ACCOUNT_USER", deleteAccountUser);
}

// export function* editSagaAccountProperties() {
//   yield takeEvery("EDIT_ACCOUNT_PROPERTIES", editAccountProperties);
// }

const getSetCookie = () => {
  return window.localStorage.getItem("uuidSetCookie");
};
